import {LobbyImage} from '@colonist/types'
import {GameTypeEnum, UIMMatchmakingController} from './UIMMatchmakingController'
import {UIMMatchmakingSelectionView} from './UIMMatchmakingSelectionView'
import {TranslationObject} from '@colonist/i18n'
import {getDescriptionForSelectedMatchTypeAndEligibility} from '../../../../../../../shared/scripts/matchmaking/MatchmakingUtilsClient'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'

export class UIMMatchmakingSelection1v1View extends UIMMatchmakingSelectionView {
    constructor(matchmakingController: UIMMatchmakingController) {
        const title: TranslationObject = {key: 'strings:homePage.ranked.1v1'}
        const imageSrc = LobbyImage.GameMode1v1

        super(matchmakingController, title, imageSrc)
        this.renderSelectionScreen()
    }

    renderSelectionScreen() {
        this.addTitle()
        this.addImage()
        this.addUnrankedButton()
        this.addRankedButton()
    }

    private addUnrankedButton() {
        const data = getDescriptionForSelectedMatchTypeAndEligibility([MatchmakingMatchTypes.UnrankedClassic1v1])
        const unrankedButton = this.addButton({key: 'strings:homePage.unranked.1v1'}, data.description, !data.eligibleForMatchType)

        unrankedButton.onclick = () => {
            this.matchmakingController.removeSelectionScreen()
            void this.matchmakingController.startSearching(GameTypeEnum.Classic1v1, false)
        }
    }

    private addRankedButton() {
        const data = getDescriptionForSelectedMatchTypeAndEligibility([MatchmakingMatchTypes.RankedClassic1v1])
        const rankedButton = this.addButton({key: 'strings:homePage.matchmakingPopup.ranked1v1'}, data.description, !data.eligibleForMatchType)

        rankedButton.onclick = () => {
            this.matchmakingController.removeSelectionScreen()
            void this.matchmakingController.startSearching(GameTypeEnum.Classic1v1, true)
        }
    }
}
